/* Keep the header and tab-bar cart badges honest.

   Both were rendered once by Liquid and never touched again, so every cart change
   made without a page load left them behind — emptying the cart from the drawer
   still showed the old count on the icon. The drawer is the Essential Cart Drawer
   app, which never reloads the page, so that was every change a shopper makes.

   Three signals feed this, because no single one covers every path: the app's own
   update event, any cart mutation that goes through fetch (the PDP add, the drawer
   rails, Dawn's forms), and a bfcache restore, where the browser hands back a page
   rendered against a cart that has since moved on. */
(function (scope) {
  'use strict';

  var COUNT_SELECTOR = '[data-cd-cart-count]';
  var LINK_SELECTOR = '[data-cd-cart-link]';
  // The stand-in the Liquid label forms carry in place of a real count.
  var COUNT_PLACEHOLDER = '1234567890';
  var lastCount = null;

  function getShopifyRoot() {
    var root = scope.Shopify && scope.Shopify.routes && scope.Shopify.routes.root;
    if (typeof root !== 'string' || !root) return '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function toCount(value) {
    var count = Number(value);
    return Number.isFinite(count) && count > 0 ? Math.round(count) : 0;
  }

  function setLabel(link, count) {
    var one = link.getAttribute('data-cd-cart-label-one');
    var other = link.getAttribute('data-cd-cart-label-other');
    if (!one || !other) return;
    var label = count === 1 ? one : other.split(COUNT_PLACEHOLDER).join(String(count));
    if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
  }

  function render(count) {
    if (typeof document === 'undefined') return;
    Array.prototype.forEach.call(document.querySelectorAll(COUNT_SELECTOR), function (node) {
      var text = String(count);
      if (node.textContent !== text) node.textContent = text;
      // An empty cart shows no badge at all, rather than a zero.
      if (count > 0) node.removeAttribute('hidden');
      else node.setAttribute('hidden', '');
    });
    Array.prototype.forEach.call(document.querySelectorAll(LINK_SELECTOR), function (link) {
      setLabel(link, count);
    });
  }

  function apply(count) {
    var next = toCount(count);
    if (next === lastCount) return next;
    lastCount = next;
    render(next);
    return next;
  }

  function refresh() {
    if (typeof scope.fetch !== 'function') return Promise.resolve(null);
    return scope
      .fetch(getShopifyRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart count request failed');
        return response.json();
      })
      .then(function (cart) {
        return apply(cart && cart.item_count);
      })
      .catch(function () {
        // Leave the last known count rather than flashing a wrong one.
        return null;
      });
  }

  function isCartMutation(input, init) {
    var url;
    try {
      url = new URL(typeof input === 'string' ? input : input && input.url, scope.location.href);
    } catch (_error) {
      return false;
    }
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    return (
      url.origin === scope.location.origin &&
      method !== 'GET' &&
      /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname)
    );
  }

  function watchFetch() {
    if (typeof scope.fetch !== 'function' || scope.fetch.__cdCartCount) return;
    var baseFetch = scope.fetch.bind(scope);
    var wrapped = function (input, init) {
      var mutating = isCartMutation(input, init);
      return baseFetch(input, init).then(function (response) {
        // A 422 still changes the cart when Shopify took part of the add.
        if (mutating) refresh();
        return response;
      });
    };
    wrapped.__cdCartCount = true;
    scope.fetch = wrapped;
  }

  function handleEssentialCartUpdate(event) {
    var cart = event && event.detail;
    if (!cart || typeof cart.item_count === 'undefined') {
      refresh();
      return;
    }
    apply(cart.item_count);
  }

  function init() {
    var seed = document.querySelector(COUNT_SELECTOR);
    lastCount = seed ? toCount(seed.textContent) : null;
    document.addEventListener('essential-cart:update', handleEssentialCartUpdate);
    scope.addEventListener('pageshow', function (event) {
      if (event.persisted) refresh();
    });
    watchFetch();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { isCartMutation: isCartMutation, toCount: toCount };
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  }
})(typeof window !== 'undefined' ? window : globalThis);
